import React from "react";
import { ReactSVG } from "react-svg";
import voiceStar from "../../../Asset/voiceStar.svg";
import copyIcon from "../../../Asset/copy-icon.svg";
import deleteIcon from "../../../Asset/delete-icon.svg";
import RecordingTray from "../RecordingTray";
import UsagePreferenceCard from "./UsagePreferenceCard";

const MainTextBoxPanel = ({
  type,
  setType,
  wordCount,
  textOut,
  refineText,
  recording,
  errorMsg,
  onCopy,
  onDelete,
  onTextChange,
  recordingTrayProps,
  formatterEnabled,
  onToggleFormatter,
}) => {
  const editorValue = refineText?.length > 0 ? refineText : textOut;

  return (
    <div className="lg:flex-[2] flex flex-col gap-4">
      <UsagePreferenceCard type={type} onTypeChange={setType} className="lg:hidden" />

      <div className="bg-white lg:h-full max-h-[70vh] min-h-[40vh] md:p-6 p-3 flex flex-col rounded-3xl border border-[#3AB1F64D]">
        <div className="flex items-center justify-between gap-2 shrink-0 pb-3">
          <div className="text-[#6B7280] md:text-sm text-xs">
            {wordCount} {wordCount === 1 ? "word" : "words"}
          </div>

          <div className="flex items-center gap-2">
            <button
              type="button"
              onClick={onToggleFormatter}
              className={`inline-flex items-center gap-1.5 rounded-lg px-2.5 py-1.5 text-xs font-medium transition ${
                formatterEnabled
                  ? "bg-[#F0FDF4] hover:bg-[#DCFCE7] text-[#16A34A]"
                  : "bg-[#F3F4F6] hover:bg-[#E5E7EB] text-[#6B7280]"
              }`}
              aria-label="Toggle formatter"
              title={formatterEnabled ? "Formatter on — click to disable" : "Formatter off — click to enable"}
            >
              <span className={`w-3 h-3 rounded-full ${formatterEnabled ? "bg-[#16A34A]" : "bg-[#9CA3AF]"}`} />
              Format
              <span className="rounded-full bg-[#FEF3C7] text-[#D97706] text-[9px] font-bold px-1.5 py-0.5 leading-none">BETA</span>
            </button>

            <button
              type="button"
              onClick={onCopy}
              className="inline-flex items-center gap-1.5 rounded-lg bg-[#F2FAFF] hover:bg-[#E8F6FF] text-[#2196F3] px-2.5 py-1.5 text-xs font-medium transition"
              aria-label="Copy text"
            >
              <ReactSVG
                src={copyIcon}
                beforeInjection={(svg) => svg.setAttribute("class", "w-3 h-3")}
                className="w-3 h-3"
              />
              Copy
            </button>

            <button
              type="button"
              onClick={onDelete}
              className="inline-flex items-center gap-1.5 rounded-lg bg-[#FFF3F3] hover:bg-[#FFEAEA] text-[#FF4D4F] px-2.5 py-1.5 text-xs font-medium transition"
              aria-label="Delete text"
            >
              <ReactSVG
                src={deleteIcon}
                beforeInjection={(svg) => svg.setAttribute("class", "w-3 h-3")}
                className="w-3 h-3"
              />
              Delete
            </button>
          </div>
        </div>

        <div className="flex flex-1 min-h-0 overflow-y-auto pt-1">
          {textOut?.length > 0 || refineText?.length > 0 ? (
            <textarea
              rows={8}
              value={editorValue}
              onChange={(event) => onTextChange?.(event.target.value)}
              className="h-full min-h-full w-full resize-none border-0 bg-transparent py-1 text-[#000] xl:text-xl lg:text-lg md:text-base text-sm font-medium font-inter leading-[1.75] outline-none"
            />
          ) : (
            <div className="text-[#C8C8C8] md:text-xl sm:text-base text-sm font-medium font-inter leading-[1.5] flex items-start gap-2">
              <ReactSVG
                src={voiceStar}
                beforeInjection={(svg) => {
                  svg.setAttribute("class", "md:w-8 w-6 h-auto");
                }}
              />
              {type === "transcription"
                ? recording
                  ? "ZeroTyping AI is listening..."
                  : "ZeroTyping AI Transcription..."
                : recording
                ? "ZeroTyping AI is listening..."
                : "ZeroTyping AI Translation..."}
            </div>
          )}

          {errorMsg ? <div className="mt-3 text-sm text-red-600 font-inter">{errorMsg}</div> : null}
        </div>

        <RecordingTray {...recordingTrayProps} />
      </div>
    </div>
  );
};

export default MainTextBoxPanel;
